if (!customElements.get('vf-color-menu')) {
  customElements.define('vf-color-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const close = () => { this.details.open = false; };
      const open = () => {
        document.querySelectorAll('[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]').forEach(details => {
          if (details !== this.details) details.open = false;
        });
        this.details.open = true;
      };
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimer);
        if (matchMedia('(hover: hover) and (pointer: fine)').matches) this.openTimer = setTimeout(open, 160);
      }, options);
      this.addEventListener('mouseleave', () => {
        clearTimeout(this.openTimer);
        this.closeTimer = setTimeout(close, 180);
      }, options);
      this.summary.addEventListener('click', event => {
        event.preventDefault();
        clearTimeout(this.openTimer);
        this.details.open ? close() : open();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          close();
          this.summary.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) close();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) close();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
    }
  });
}
